import { render, staticRenderFns } from "./breakdown.vue?vue&type=template&id=0a8ea582"
import script from "./breakdown.vue?vue&type=script&lang=js"
export * from "./breakdown.vue?vue&type=script&lang=js"
import style0 from "./breakdown.vue?vue&type=style&index=0&id=0a8ea582&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports